const lastActivity = activities =>
  activities && activities.length && activities[activities.length - 1];

export const hasGeolocation = activities => {
  const activity = lastActivity(activities);

  if (!activity) {
    return false;
  }

  return (
    activity.channelData &&
    activity.channelData.quick_replies &&
    activity.channelData.quick_replies[0] &&
    activity.channelData.quick_replies[0].content_type === 'location'
  );
};

export const showUploadButton = activities => {
  const activity = lastActivity(activities);

  if (!activity) {
    return false;
  }

  return activity.inputHint === 'attachment';
};

export const hasQuickReplies = activities => {
  const activity = lastActivity(activities);

  if (!activity) {
    return false;
  }

  return !!activity.suggestedActions;
};

export const isShowingButton = activities =>
  hasGeolocation(activities) || hasQuickReplies(activities) || showUploadButton(activities);



// WEBPACK FOOTER //
// ./src/reducers/history/utils.js